export const EVENT = {
    REFRESH: 'refresh',
    DATA_NOCACHE_AUTH: 'datanocache_auth',
    UPDATE_SPORTS_TORE: 'update_sports_store',
    GET_DATA_NOCACHE: 'get.datanocache',
    ACCOUNT_BALANCE_RELOAD: 'ACCOUNT_BALANCE_RELOAD',
    LANGUAGE_CHANGE: 'language_change',
    ErrorsHappenOnPage: 'errors_happen_on_page',
    CSS_LOADED: 'CSS_LOADED',
    OPEN_ALERT: 'OPEN_ALERT',
    CLOSE_ALERT: 'CLOSE_ALERT',
    FIRST_LOGIN: 'FIRST_LOGIN',
    SHOW_MESSAGE_POPUP: 'SHOW_MESSAGE_POPUP',
    GENERATE_TOAST: 'GENERATE_TOAST',
    CLEAR_ALL_TOASTS: 'CLEAR_ALL_TOASTS',
    GENERATE_ADDING_SELECTION_TOAST: 'GENERATE_ADDING_SELECTION_TOAST',
    OPEN_POPUP_MODAL: 'OPEN_POPUP_MODAL',
    OPEN_POPUP_WITH_CANCEL_MODAL: 'OPEN_POPUP_WITH_CANCEL_MODAL',
    CLOSE_POPUP_MODAL: 'CLOSE_POPUP_MODAL',
    OPEN_BETSLIP: 'OPEN_BETSLIP',
    GET_TEASER_ODDS: 'GET_TEASER_ODDS',
    USER_LOG_OUT: 'USER_LOG_OUT',
    LEFT_MENU_CHANGE_BETTYPE_GROUP:'LEFT_MENU_CHANGE_BETTYPE_GROUP',
    LEFT_MENU_CHANGE_TAB:'LEFT_MENU_CHANGE_TAB',
    LEFT_MENU_CHANGE_OPTIONS:'LEFT_MENU_CHANGE_OPTIONS',
    LEFT_MENU_CASINO_SELECTED:'LEFT_MENU_CASINO_SELECTED',
    LEFT_MENU_BET_BUILDER_SELECTED: 'LEFT_MENU_BET_BUILDER_SELECTED',
    LEFT_MENU_LIVE_CASINO_SELECTED: 'LEFT_MENU_LIVE_CASINO_SELECTED',
    LEFT_MENU_RESET_OPTIONS: 'LEFT_MENU_RESET_OPTIONS',
    FETCH_CASINO_GAMES: 'FETCH_CASINO_GAMES',
    FETCH_LIVE_CASINO_GAMES: 'FETCH_LIVE_CASINO_GAMES',
    OPEN_LOGIN: 'OPEN_LOGIN',
    UPDATE_PERIODS_DESC: 'update.periods.desc',
    /**
     * Spinner Event
     */
    START_SPINNING: 'spinning.start',
    STOP_SPINNING: 'spinning.stop',
    API_SERVICE_ERROR: 'API_SERVICE_ERROR',
    
    CALL_MY_BETS_SERVICE: 'CALL_MY_BETS_SERVICE',
    BACK_TO_TOP: 'BACK_TO_TOP',
    
    CLOSE_SIDE_BAR: 'CLOSE_SIDE_BAR',
    MULTIPLE_LOGIN: 'MULTIPLE_LOGIN',
    REFRESH_QUICK_FILTER: 'refresh.quick.filter',
    REFRESH_SPORT_FILTER: 'refresh.sport.filter',
    REFRESH_WAGERS: 'refresh.wagers',
    REFRESH_STATEMENTS: 'refresh.statements',
    CANCEL_TERMS_CONDITIONS: 'cancel.terms.conditions',
    CONTINUE_TERMS_CONDITIONS: 'continue.terms.conditions',
    REFRESH_DATA: 'refresh.data',
    CHECK_VALID_PAGE: 'check.valid.page',

    WINDOW_GO_TO_REGISTER_PAGE: 'window.goto.register.page',
    REFRESH_LEFT_MENU: 'REFRESH_LEFT_MENU',

    /**
     * Max Bet Setting BASE
     */
    UPDATE_MAX_BET_PREFERENCE_SETTING_BASE: "update.max.bet.preference.setting.base",
    SCROLL_TO_LEADER_BOARD_TNC: "scroll.to.leader.board.tnc",
    EXPAND_TNC_LEADER_BOARD: "expand.tnc.leader.board",
    
    /**
     * Use for click FIND OUT MORE button
     */
     FIND_OUT_MORE: "find.out.more",

     /**
     * New Betslip 
     */
     CLEAR_PENDING_BET_TOAST: "CLEAR_PENDING_BET_TOAST",
}


// WEBPACK FOOTER //
// ./src/app/common/events/listEvents.js